export const applicationRouteNames = {
  home: 'projects',
  project: 'projects/:id',
  phase: 'phases/:phaseId',
  scenarioDetails: 'scenarios/:scenarioId',
  administration: 'administration',
  users: 'users',
  referentials: 'referentials',
  lokalise: 'lokalise',
  globalRates: 'global-rates',
};
